import { Box } from '@factorialco/deprecated-design-system'
import { CoCreationForm, CoCreationFormElement } from '@factorialco/f0-react/dist/experimental'

import {
  FromFormToQuestionnaire,
  FromQuestionnaireToForm,
} from 'modules/forms/components/newFormEditor/helpers'

import { QuestionnaireType } from './types'

interface FormEditorProps {
  state: QuestionnaireType
  setState: (state: QuestionnaireType) => void
}

export const FormEditor = ({ state, setState }: FormEditorProps) => {
  const elements = FromQuestionnaireToForm(state.elements)

  const handleChange = (updatedElements: CoCreationFormElement[]) => {
    setState?.({ ...state, elements: FromFormToQuestionnaire(updatedElements) })
  }

  return (
    <Box gap="s16" width="s600" alignSelf="center" height="full">
      <CoCreationForm isEditMode elements={elements} onChange={handleChange} />
    </Box>
  )
}
